/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { site } from '@panel/commons/helpers';
import PaymentFormProvider from './sections/form/formProvider';
import PaymentForm from './sections/form/form';
import PhoneForm from './sections/form/phoneForm';
import ContactSuccess from './sections/checkout/contactSuccess';
import PurchaseDetails from './sections/details/purchaseDetails';
import PaymentError from './sections/checkout/paymentError';
import PaymentSuccess from './sections/checkout/paymentSuccess';
import { Step4Module2Container, Title, FormContainer } from './styles';
import { WrapperContainer } from '../../Wrappers/WrapperContainer';
import PayPalForm from './sections/form/payPalForm';
import WireTransferInfo from './sections/checkout/wireTransferInfo';
import { getEcommerceUser } from '../../../ducks/step4Module2';

const Step4Module2 = WrapperContainer(({ setId }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();

  const routes = {
    PAYMENT: `${path}`,
    PAYMENT_ERROR: `${path}/error`,
    PAYMENT_SUCCESS: `${path}/exito`
  };
  const formName = site.isEcuador ? 'step4Module2FormContact' : 'step4Module2Form';

  useEffect(() => {
    setId(formName);
  }, [setId, formName]);
  useEffect(() => {
    if (!site.isEcuador && !site.isPanama) {
      dispatch(getEcommerceUser());
    }
  }, [dispatch]);

  return (
    <Step4Module2Container>
      <PaymentFormProvider>
        <FormContainer>
          <Switch>
            <Route path={routes.PAYMENT} exact>
              <Title main>{t('publisher.step4.module2.progressStepName')}</Title>
              {site.isEcuador ? <PhoneForm /> : site.isPanama ? <PayPalForm /> : <PaymentForm />}
            </Route>
            <Route path='/publicador/planes/pago/transferencia'>
              <WireTransferInfo />
            </Route>
            <Route path={routes.PAYMENT_ERROR} exact>
              <PaymentError />
            </Route>
            <Route path={routes.PAYMENT_SUCCESS} exact>
              {site.isEcuador ? <ContactSuccess /> : <PaymentSuccess />}
            </Route>
          </Switch>
        </FormContainer>
        <PurchaseDetails />
      </PaymentFormProvider>
    </Step4Module2Container>
  );
});

export default Step4Module2;
